import { render } from "./EventPageBlockRenderer.vue?vue&type=template&id=d51fad62"
import script from "./EventPageBlockRenderer.vue?vue&type=script&lang=js"
export * from "./EventPageBlockRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__